import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";
import { useLang, CONTACT } from "../../translations";

const links = ["about", "expertise", "journey", "location", "faq", "contact"];

export const Footer = () => {
  const { t } = useLang();
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer data-testid="site-footer" className="bg-ink text-cream/80 pt-20 pb-10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12 grid md:grid-cols-3 gap-12">
        <div>
          <p className="font-heading text-3xl text-cream leading-none">{CONTACT.name}</p>
          <p className="text-xs uppercase tracking-[0.24em] text-sage mt-2">Homéopathie Classique · ASCA</p>
          <p className="mt-6 text-sm leading-relaxed max-w-xs">{t.footer.tagline}</p>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.24em] text-cream/50 mb-5">{t.footer.quick}</p>
          <ul className="space-y-3">
            {links.map((l) => (
              <li key={l}>
                <button data-testid={`footer-nav-${l}`} onClick={() => go(l)} className="text-sm hover:text-sage transition-colors duration-300">
                  {t.nav[l] || t.nav.contact}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.24em] text-cream/50 mb-5">{t.footer.contactTitle}</p>
          <ul className="space-y-4 text-sm">
            <li className="flex items-start gap-3"><MapPin size={16} className="text-sage mt-0.5" /> {CONTACT.address}</li>
            <li><a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-3 hover:text-sage transition-colors"><Phone size={16} className="text-sage" /> {CONTACT.phone}</a></li>
            <li><a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 hover:text-sage transition-colors"><Mail size={16} className="text-sage" /> {CONTACT.email}</a></li>
          </ul>
        </div>
      </div>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12 mt-14 pt-6 border-t border-cream/10 text-xs text-cream/50">
        © {new Date().getFullYear()} {CONTACT.name}. {t.footer.rights}
      </div>
    </footer>
  );
};
